import PropTypes from 'prop-types';
import React from 'react';

function PlayIcon({title, subText}) {
  return (
    <div className="play-icon">
      <span>{subText}</span>
      <svg viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
        <g fillRule="evenodd">
          <g transform="translate(-1566.000000, -367.000000)">
            <g transform="translate(1365.000000, 35.000000)">
              <path d="M233,396 C250.673112,396 265,381.673112 265,364 C265,346.326888 250.673112,332 233,332 C215.326888,332 201,346.326888 201,364 C201,381.673112 215.326888,396 233,396 Z M229.316844,378.728219 L229.513822,378.559469 L244.193419,365.809375 C244.690462,365.378219 245,364.73125 245,364.009469 C245,363.287594 244.681176,362.640625 244.193419,362.209469 L229.541868,349.46875 L229.298084,349.253219 C229.063586,349.09375 228.782188,349 228.48203,349 C227.665882,349 227,349.693844 227,350.556344 L227,377.443844 C227,378.306344 227.665882,379 228.48203,379 C228.791474,379 229.082345,378.896969 229.316844,378.728219 Z"/>
            </g>
          </g>
        </g>
      </svg>      
    </div>
  );
}

PlayIcon.propTypes = {
  title: PropTypes.string.isRequired,
  subText: PropTypes.string
}

export default PlayIcon



// WEBPACK FOOTER //
// ./modules/Common/components/svg/PlayIcon.js